<template>
	<el-drawer class="materialpreview" title="报告" :visible.sync="visible" direction="rtl" size="70%" @opened="opened"
		@closed="closed" destroy-on-close>
		<el-tabs v-model="activeName" tab-position="left" style="height: 100%;">
			<el-tab-pane v-for="(item,index) in tab" :label="item.type" :key="index" :name="item.type">
				<upload ref="upload" :value="item.file" :downloadConfig="downloadConfig" :disabled="true" :formCreateInject="true" />
			</el-tab-pane>
		</el-tabs>
	</el-drawer>
</template>
<style>
	.materialpreview .el-upload-list__item {
		width: 200px !important;
		height: 200px !important;
	}

	.materialpreview .el-upload--picture-card {
		display: none !important;
	}
</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				activeName: '',
				tab: [],
				visible: false,
				downloadConfig:{
					name:{
						prefix:'prefix',
						suffix:'',
					}
				}
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {
			row(e){
				if(e){
					if(!this.row.specCode){
						this.downloadConfig.name.prefix = '【'+this.getcurrenttype()+'】' + this.row.goodsCode + '_' +this.row.goodsName
					}else{
						this.downloadConfig.name.prefix = '【'+this.getcurrenttype()+'】' + this.row.specCode + '_' +this.row.goodsName +'_'+this.row.specName
					}
				}
			}
		},
		computed: {

		},

		methods: {
			// beforeDownload(e){
			// 	e.file.name = '下载测试.png'
			// },
			show() {
				this.visible = true
			},
			opened() {
				this.tab = this.row.file
				this.activeName = this.getcurrenttype()
				console.log(this.row)
			},
			getcurrenttype(){
				let type = ''
				this.row.file.forEach((item) => {
					if (item.active == 1) {
						type = item.type
					}
				})
				return type
			},
			closed() {
				this.tab = []
			}
		},
		components: {
			upload
		}
	}
</script>